import React from "react";
import { Link, Box, Button, Typography } from "@mui/material";
import { useTranslation } from "react-i18next";

const FileDetailPanel = ({
  filePath,
  fileName,
  onProvideFeedback,
  hasPublishedFeedback
}) => {
  const { t } = useTranslation();
  return (
    <Box
      display="flex"
      flexDirection="column"
      pl={8.75}
      pb={3.5}
      alignItems="flex-start"
    >
      <Typography
        variant="subtitle2"
        color="textSecondary"
        sx={{ pt: 1, pr: 1 }}
      >
        {t("homeworkSubmission.fileSubmitted")}
      </Typography>
      <Link href={filePath} target="_blank">
        <h3>{fileName}</h3>
      </Link>
      <Box pt={3.5} ml={hasPublishedFeedback ? -2 : 0}>
        <Button
          variant={hasPublishedFeedback ? "text" : "contained"}
          color="primary"
          onClick={() => onProvideFeedback()}
        >
          {hasPublishedFeedback
            ? t("homeworkSubmission.viewFeedbackBtn")
            : t("homeworkSubmission.provideFeedbackBtn")}
        </Button>
      </Box>
    </Box>
  );
};

export default FileDetailPanel;
